function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

// Function to get the redirect URL, defaulting to /account if not specified or if it's the auto-login/login page
function getRedirectUrl() {
    const redirectParam = getUrlParameter('redirect');
    
    if (!redirectParam) {
        return '/account';
    }
    
    // Decode the redirect URL
    const decodedRedirect = decodeURIComponent(redirectParam);
    
    // Check if the redirect URL is pointing to problematic pages to prevent loops or unwanted redirects
    if (decodedRedirect.includes('/pages/auto-login') || decodedRedirect.includes('/account/login')) {
        return '/account';
    }
    
    return decodedRedirect;
}

// Function to check if user is already logged in
async function isUserLoggedIn() {
    try {
        const response = await fetch('https://store.rockmy.com/account', {
            method: 'GET',
            credentials: 'include',
            redirect: 'manual'  // Don't follow redirects automatically
        });
        
        // If we get a redirect to login page, user is not logged in
        if (response.status === 302 || response.status === 301) {
            const location = response.headers.get('Location');
            if (location && location.includes('/account/login')) {
                return false;
            }
        }
        
        // If we get a successful response, check the content
        if (response.ok) {
            const text = await response.text();
            // Look for indicators that user is logged in
            if (text.includes('/account/logout') || text.includes('Welcome') || text.includes('My Account')) {
                return true;
            }
        }
        
        return false;
    } catch (error) {
        console.error('Error checking login status:', error);
        // If we can't determine, assume not logged in to be safe
        return false;
    }
}

const ROCKMY_API_BASE = 'https://rockmy.com/wp-json/wp-shopify-login/v1';
const SHOPIFY_LOGIN_CALLBACK = `${ROCKMY_API_BASE}/shopify-login-callback`;

async function callShopifyCallback(authToken) {
    try {
        let resetUrl = `${SHOPIFY_LOGIN_CALLBACK}?auth-token=${encodeURIComponent(authToken)}`;
         // Add already_logged parameter if user is already logged in
      const alreadyLoggedIn = await isUserLoggedIn();
        if (alreadyLoggedIn) {
            resetUrl += '&already_logged=1';
        }
        const response = await fetch(resetUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        
        const data = await response.json();
        
        if (response.ok && data.success) {
            console.log('Callback successful:', data);
            return {
                success: true,
                email: data.email,
                password: data.password,
                customer_id: data.customer_id
            };
        } else {
            console.error('Callback failed:', data);
            return {
                success: false,
                error: data.message || 'Callback failed'
            };
        }
    } catch (error) {
        console.error('Callback API error:', error);
        return {
            success: false,
            error: 'Network error calling Callback API'
        };
    }
}

async function autoLogin() {
    // Get the redirect URL first
    const redirectUrl = getRedirectUrl();
    
    
    
    const identity = getUrlParameter('identity');
    const token = getUrlParameter('token');
    const authtoken = getUrlParameter('auth-token');
    const activatetoken = getUrlParameter('activatetoken');
    const activateid = getUrlParameter('activateid');


  // Check if user is already logged in
    console.log('Checking if user is already logged in...');
    const alreadyLoggedIn = await isUserLoggedIn();
    
    if (alreadyLoggedIn) {
        console.log('User is already logged in, redirecting to:', redirectUrl);
        callShopifyCallback(authtoken);
        window.location.href = redirectUrl;
        return;
    }
    
    console.log('User is not logged in, proceeding with auto-login...');
    // Handle account activation flow
    if (activatetoken || activateid) {
        let loginEmail, loginPassword;

        // If auth-token is present, use it to get credentials
        if (authtoken) {
            console.log('Using auth-token to get credentials');
            const resetResult = await callShopifyCallback(authtoken);
            
            if (resetResult.success) {
                loginEmail = resetResult.email;
                loginPassword = resetResult.password;
                console.log('Got credentials from auth-token');
            } else {
                console.error('Failed to get credentials from auth-token:', resetResult.error);
                // window.location.href = redirectUrl;
                return;
            }
        } else if (identity && token) {
            // Fallback to URL parameters if no auth-token
            loginEmail = identity;
            loginPassword = token;
            console.log('Using URL parameters for login');
        } else {
            console.error('Auth missing - no auth-token or identity/token parameters');
            // window.location.href = redirectUrl;
            return;
        }
          
        const postData = new URLSearchParams({
            'form_type': 'activate_customer_password',
            'utf8': '✓',
            'token': activatetoken,
            'customer[password]': loginPassword,
            'customer[password_confirmation]': loginPassword,
            'id': activateid
        });

        try {
            const response = await fetch('https://store.rockmy.com/account/activate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: postData.toString(),
                credentials: 'include',
                redirect: 'follow'
            });

            const text = await response.text();

            if (response.ok) {
                if (text.includes("/account/logout") || text.includes("Welcome")) {
                    // console.log('Activation successful');
                    window.location.href = redirectUrl;
                } else {
                    // window.location.href = redirectUrl;
                    console.warn('Activation request was OK, but login may have failed. Check the page output:', text);
                }
            } else {
                // window.location.href = redirectUrl;
                console.error(`Activation failed with status ${response.status}`);
            }
        } catch (error) {
            // window.location.href = redirectUrl;
            console.error('Activation error:', error);
        }
        return;
    }

    let loginEmail, loginPassword;

    // If auth-token is present, use it to get credentials
    if (authtoken) {
        console.log('Using auth-token to get credentials');
        const resetResult = await callShopifyCallback(authtoken);
        
        if (resetResult.success) {
            loginEmail = resetResult.email;
            loginPassword = resetResult.password;
            console.log('Got credentials from auth-token');
        } else {
            console.error('Failed to get credentials from auth-token:', resetResult.error);
            // window.location.href = redirectUrl;
            return;
        }
    } else if (identity && token) {
        // Fallback to URL parameters if no auth-token
        loginEmail = identity;
        loginPassword = token;
        console.log('Using URL parameters for login');
    } else {
        console.error('Auth missing - no auth-token or identity/token parameters');
        // window.location.href = redirectUrl;
        return;
    }

    const postData = new URLSearchParams({
        'form_type': 'customer_login',
        'utf8': '✓',
        'customer[email]': loginEmail,
        'customer[password]': loginPassword
    });

    try {
        const response = await fetch('https://store.rockmy.com/account/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: postData.toString(),
            credentials: 'include',
            redirect: 'follow'
        });

        const text = await response.text();

        if (response.ok) {
            if (text.includes("/account/logout") || text.includes("Welcome")) {
                console.log('Login successful, redirecting to:', redirectUrl);
                window.location.href = redirectUrl;
            } else {
                // window.location.href = redirectUrl;
                console.warn('Login request was OK, but login may have failed. Check the page output:', text);
            }
        } else {
            // window.location.href = redirectUrl;
            console.error(`Login failed with status ${response.status}`);
        }
    } catch (error) {
        // window.location.href = redirectUrl;
        console.error('Login error:', error);
    }
}

// Execute on page load
autoLogin();